const DB_NAME = 'fretflow_songs';
const DB_VERSION = 1;
const SONGS_STORE = 'songs';
const PRESETS_STORE = 'presets';

const openDB = () =>
  new Promise((resolve, reject) => {
    if (!window.indexedDB) return reject(new Error('IndexedDB non disponibile'));
    const req = indexedDB.open(DB_NAME, DB_VERSION);
    req.onerror = () => reject(new Error('Impossibile aprire il database locale'));
    req.onsuccess = () => resolve(req.result);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(SONGS_STORE)) db.createObjectStore(SONGS_STORE, { keyPath: 'id' });
      if (!db.objectStoreNames.contains(PRESETS_STORE)) db.createObjectStore(PRESETS_STORE, { keyPath: 'songId' });
    };
  });

const tx = (db, store, mode) => db.transaction(store, mode).objectStore(store);

export const getAllSongs = async () => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const req = tx(db, SONGS_STORE, 'readonly').getAll();
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
};

export const saveSong = async (song) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const t = db.transaction(SONGS_STORE, 'readwrite');
    t.objectStore(SONGS_STORE).put(song);
    t.oncomplete = () => resolve();
    t.onerror = () => reject(t.error);
  });
};

export const deleteSong = async (id) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const t = db.transaction(SONGS_STORE, 'readwrite');
    t.objectStore(SONGS_STORE).delete(id);
    t.oncomplete = () => resolve();
    t.onerror = () => reject(t.error);
  });
};

export const getPreset = async (songId) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const req = tx(db, PRESETS_STORE, 'readonly').get(songId);
    req.onsuccess = () => resolve(req.result || null);
    req.onerror = () => reject(req.error);
  });
};

export const savePreset = async (preset) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const t = db.transaction(PRESETS_STORE, 'readwrite');
    t.objectStore(PRESETS_STORE).put(preset);
    t.oncomplete = () => resolve();
    t.onerror = () => reject(t.error);
  });
};

export const deletePreset = async (songId) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const t = db.transaction(PRESETS_STORE, 'readwrite');
    t.objectStore(PRESETS_STORE).delete(songId);
    t.oncomplete = () => resolve();
    t.onerror = () => reject(t.error);
  });
};
